import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { DateFormateChange, debouncing, maxLengthCheck } from '../../../utils/helper';
import { DONATION_ADD, ERROR_CODE } from '../../../constant';
import OrgContext from '../../../context/OrgContext/OrgContext';
import { Donation_bill_Details } from '../../../api/DonationBillApi/DonationCillapi';
import LogOut from '../../../utils/logout';
import { Zoom, toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DialCodeList } from '../../../api/DialCodeApi/DialCodeApi';
import { GujaratiDays } from '../../../api/GujaratiMonthApi/GujaratiDayApi';
import { GujaratiMonths } from '../../../api/GujaratiMonthApi/GujaratiMonthApi';
import { DonarList } from '../../../api/Donar Api/DonarApi';
import TithiDropDown from '../../../common/TithiDropDown';
import { useNavigate } from 'react-router';
import Select from 'react-select';

const DonationUserDatails = ({ isHide, isEdit = false }) => {
  const {
    address,
    setAddress,
    name,
    setName,
    contactNo,
    setContactNo,
    village,
    setVillage,
    pancard,
    setPanCard,
    aadhaarCard,
    setAadhaarCard,
    byHand,
    setByhand,
    setDob,
    dob,
    setCity,
    setState,
    setCountry,
    setPersonaId,
    dialCode,
    setDialCode,
    isAksharvashi,
    setIsAksharvashi,
    dialCodeJson,
    setDialCodeJson,
    persons,
    setPersons,
    setGujaratiDate,
    setGujaratiMonth,
    dialCodeKin,
    setDialCodeKin,
    contactNoKin,
    setContactNoKin,
    setDodMonth,
    setdodPaksha,
    setDodDate,
    isWpNumber,
    setIsWpNumber
  } = useContext(OrgContext);

  const emptyFeilds = () => {
    setVillage('');
    setContactNo('+91');
    setPanCard('');
    setAadhaarCard('');
    setCity('');
    setState('');
    setCountry('');
    setContactNoKin('');
    setAddress('');
    setDob('');
    setPersonaId('');
    setName('');
    setPersons([]);
    setShowSuggestions(false);
    setIsAksharvashi(false);
  };
  const history = useNavigate();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  useEffect(() => {
    setFocusedIndex(-1);
  }, [persons, showSuggestions]);

  const showHandle = async ({ mobile, personId, isContact }) => {
    try {
      let paramObj = {};
      if (personId) {
        paramObj['personId'] = personId;
      } else {
        paramObj['mobile'] = mobile;
      }
      const { data } = await Donation_bill_Details(paramObj);
      if (data.status === 200) {
        let payload = data.payload.data;
        setIsWpNumber(
          mobile?.length || (payload?.mobile && payload?.mobile?.split(' ')[1]?.length) ? data.payload?.isWpNumber : ''
        );
        setPersonaId(payload && payload.personId ? payload.personId : '');
        setName(payload && payload.name ? payload.name : '');
        setVillage(payload && payload.village ? payload.village : '');
        setPanCard(payload && payload.panCardNo ? payload.panCardNo : '');
        setAadhaarCard(payload && payload.aadhaarCard ? payload.aadhaarCard : '');
        if (isContact) {
          setContactNo(payload?.mobile ? payload?.mobile?.split(' ')?.pop() : '');
        }
        setDialCodeKin(payload?.kinMobile ? payload?.kinMobile?.split(' ')[0] : '+91');
        setContactNoKin(payload?.kinMobile ? payload?.kinMobile?.split(' ')[1] : '');
        setDob(payload && payload.dob ? new Date(DateFormateChange(payload.dob)) : '');
        setCity(payload && payload.city ? payload.city : '');
        setState(payload && payload.state ? payload.state : '');
        setCountry(payload && payload.country ? payload.country : '');
        setAddress(payload && payload.address ? payload.address : '');
        if (mobile) {
          setPersons([]);
          setShowSuggestions(false);
        }
        setIsAksharvashi(payload && payload.isDeath ? payload.isDeath : false);
        if (payload && payload.isDeath) {
          const [month, paksha, day] = payload.dod.split('-');
          setDodMonth(month);
          setdodPaksha(paksha);
          setDodDate(day);
        }
      } else {
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const mobileSearch = async ({ mobile }) => {
    try {
      let paramObj = {
        search: { mobile },
        isDonationAdd: true
      };
      const { data } = await DonarList(paramObj);
      if (data.status === 200) {
        setPersons(data.payload.data);
        setShowSuggestions(true);
        if (data.payload.data.length === 1) {
          const userData = data.payload.data[0];
          setIsWpNumber(
            mobile?.length || (userData?.mobile && userData?.mobile?.split(' ')[1]?.length)
              ? data.userData?.isWpNumber
              : ''
          );
          setPersonaId(userData && userData.personId ? userData.personId : '');
          setName(userData && userData.name ? userData.name : '');
          setVillage(userData && userData.village ? userData.village : '');
          setPanCard(userData && userData.panCardNo ? userData.panCardNo : '');
          setAadhaarCard(userData && userData.aadhaarCard ? userData.aadhaarCard : '');

          setContactNo(userData?.mobile ? userData?.mobile?.split(' ')?.pop() : '');
          setDialCodeKin(userData?.kinMobile ? userData?.kinMobile?.split(' ')[0] : '+91');
          setContactNoKin(userData?.kinMobile ? userData?.kinMobile?.split(' ')[1] : '');
          setDob(userData && userData.dob ? new Date(DateFormateChange(userData.dob)) : '');
          setCity(userData && userData.city ? userData.city : '');
          setState(userData && userData.state ? userData.state : '');
          setCountry(userData && userData.country ? userData.country : '');
          setAddress(userData && userData.address ? userData.address : '');

          setIsAksharvashi(userData && userData.isDeath ? userData.isDeath : false);
          if (userData && userData.isDeath) {
            const [month, paksha, day] = userData.dod.split('-');
            setDodMonth(month);
            setdodPaksha(paksha);
            setDodDate(day);
          }
        } else if (!data.payload.data.length) {
          setIsWpNumber('');
          setPersonaId('');
          setName('');
          setVillage('');
          setPanCard('');
          setAadhaarCard('');

          setDialCodeKin('+91');
          setContactNoKin('');
          setDob('');
          setCity('');
          setState('');
          setCountry('');
          setAddress('');
          if (mobile) {
            setPersons([]);
            setShowSuggestions(false);
          }
          setIsAksharvashi(false);
          setDodMonth('');
          setdodPaksha('');
          setDodDate('');
        }
      } else {
        setPersons([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  useEffect(() => {
    setDialCodeJson(DialCodeList());
    setGujaratiDate(GujaratiDays());
    setGujaratiMonth(GujaratiMonths());
  }, []);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleContactChange = async (e) => {
    setContactNo(e.target.value);
    if (!isEdit && e.target.value.length === 10) {
      let joinValue = `${dialCode} ${e.target.value}`;
      // showHandle({ mobile: joinValue, isContact: false });
      mobileSearch({ mobile: joinValue, isContact: false });
    } else if (!isEdit && e.target.value.length === 0) {
      setIsWpNumber('');
      emptyFeilds();
    }
  };

  const handlePersonClick = ({ name, personId, mobile }) => {
    showHandle({ personId: personId, isContact: true });
    setPersons([]);
    setShowSuggestions(false);
  };

  const getData = async (person) => {
    try {
      let paramObj = {
        search: {
          name: person,
          ...(contactNo && contactNo.length === 10 && { mobile: contactNo })
        }
      };
      const { data } = await DonarList(paramObj);
      if (data.status === 200) {
        setPersons(data.payload.data);
        setShowSuggestions(true);
      } else {
        setPersons([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const handleChangeNameSearch = (e) => {
    let value = e.target.value;
    setName(value);
    if (!isEdit && e.target.value) {
      debouncing({ callback: getData, args: value, time: 700 });
    } else if (!isEdit) {
      emptyFeilds();
      setIsWpNumber('');
    }
  };

  const addNewRelative = () => {
    console.log('contactNo >> ', contactNo);

    setDialCodeKin(dialCode);
    setContactNoKin(contactNo);
    setIsWpNumber('');
    setPersonaId('');
    setName('');
    setVillage('');
    setPanCard('');
    setAadhaarCard('');
    setContactNo('');
    setDob('');
    setCity('');
    setState('');
    setCountry('');
    setAddress('');
    setPersons([]);
    setShowSuggestions(false);
    setIsAksharvashi(false);
  };

  const handleAksharvashi = (e) => {
    setIsAksharvashi(e.target.checked);
  };
  const [isOpen, setIsOpen] = useState(false);

  const dobRef = useRef(null);
  const nextInputRef = useRef(null);

  const dialCodeOptions = dialCodeJson.map((elem) => ({
    value: elem.code,
    label: elem.country
  }));

  const selectedDialCode = dialCodeOptions.find((opt) => opt.value === dialCode) || (dialCode ? { value: dialCode, label: dialCode } : null);
  const selectedDialCodeKin = dialCodeOptions.find((opt) => opt.value === dialCodeKin) || (dialCodeKin ? { value: dialCodeKin, label: dialCodeKin } : null);

  const customDialCodeSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: '140px',
      minWidth: '130px',
      marginRight: '6px'
    }),
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
      height: '38px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '38px',
      padding: '0 6px'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '38px'
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  };

  return (
    <>
      <Col md="4 mb-4">
        <Label htmlFor="validationCustom01" className={'d-flex gap-2'}>
          {DONATION_ADD.CONTACT_NO}{' '}
          <p style={{ color: isWpNumber ? 'green' : 'red' }}>
            {isWpNumber
              ? '(Number is registered on WhatsApp)'
              : isWpNumber === false
                ? '(Number is not registered on WhatsApp)'
                : ''}
          </p>
        </Label>
        <div className="d-flex align-items-center">
          <Select
            options={dialCodeOptions}
            value={selectedDialCode}
            onChange={(selected) => setDialCode(selected ? selected.value : '')}
            placeholder="-- select --"
            isSearchable={true}
            styles={customDialCodeSelectStyles}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          />
          <Input
            className="form-control"
            name="mobile"
            ref={inputRef}
            autoFocus
            type="number"
            placeholder={DONATION_ADD.CONTACT_NO}
            id="contact-no"
            min={0}
            maxLength={10}
            onInput={maxLengthCheck}
            onWheel={(e) => e.target.blur()}
            value={contactNo}
            onChange={(e) => handleContactChange(e)}
          />
          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
        </div>
      </Col>
      <Col md="4 mb-4">
        <div className="d-flex ">
          <Label htmlFor="validationCustom01">{DONATION_ADD.NAME}</Label>
          <div className="d-flex align-items-center px-3 pb-2">
            <input type="checkbox" className="form-checkbox" onChange={handleAksharvashi} checked={isAksharvashi} />
            <p className="px-2"> (અક્ષર નિવાસી)</p>
          </div>
        </div>
        <div className="searchable-input-container">
          <Input
            className="form-control"
            name="name"
            type="text"
            placeholder={DONATION_ADD.NAME}
            id="validationCustom01"
            value={name}
            onChange={(e) => {
              handleChangeNameSearch(e);
              setShowSuggestions(true);
            }}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => {
              // delay so click on suggestion still works
              setTimeout(() => setShowSuggestions(false), 150);
            }}
            onKeyDown={(e) => {
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                setFocusedIndex((prev) => (prev < persons.length - 1 ? prev + 1 : prev));
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                setFocusedIndex((prev) => (prev > 0 ? prev - 1 : -1));
              } else if (e.key === 'Enter') {
                e.preventDefault(); // prevent form submit
                if (showSuggestions && persons?.length > 0) {
                  const idx = focusedIndex === -1 ? 0 : focusedIndex;
                  if (idx >= 0 && idx < persons.length) {
                    handlePersonClick({
                      name: persons[idx].name,
                      personId: persons[idx].personId,
                      mobile: persons[idx].mobile
                    });
                  }
                }
              } else if (e.key === 'Tab') {
                if (showSuggestions && persons?.length > 0) {
                  const idx = focusedIndex === -1 ? 0 : focusedIndex;
                  if (idx >= 0 && idx < persons.length) {
                    handlePersonClick({
                      name: persons[idx].name,
                      personId: persons[idx].personId,
                      mobile: persons[idx].mobile
                    });
                  }
                }
                setShowSuggestions(false);
              }
            }}
            autoComplete="off"
            required
          />
          <ul className="suggestions-list" style={{ display: showSuggestions && persons?.length ? 'block' : 'none' }}>
            {persons.map((person, index) => (
              <li
                key={index}
                onMouseDown={(e) => {
                  e.preventDefault(); // Prevents blur from firing on input
                  handlePersonClick({
                    name: person.name,
                    personId: person.personId,
                    mobile: person.mobile
                  });
                }}
                style={{
                  backgroundColor: focusedIndex === index ? '#f0f0f0' : 'transparent',
                  cursor: 'pointer',
                  padding: '8px 10px',
                  borderBottom: '1px solid #eee'
                }}
                onMouseEnter={() => setFocusedIndex(index)}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{person.name}</span>
                  {person.mobile && <span style={{ fontSize: '0.9em', color: '#666' }}>{person.mobile}</span>}
                </div>
              </li>
            ))}
            <Button
              className="w-100"
              onMouseDown={(e) => {
                e.preventDefault();
                addNewRelative();
              }}
            >
              Add New Relative
            </Button>
          </ul>
        </div>
        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
      </Col>
      <Col md="4 mb-4">
        <Label htmlFor="validationCustom01">{DONATION_ADD.VILLAGE}</Label>
        <Input
          className="form-control"
          name="village"
          type="text"
          placeholder={DONATION_ADD.VILLAGE}
          id="validationCustom01"
          value={village}
          onChange={(e) => setVillage(e.target.value)}
        />
        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
      </Col>
      <Col md="4 mb-4">
        <Label htmlFor="validationCustom01">{DONATION_ADD.RELATIVE_NO}</Label>
        <div className="d-flex align-items-center">
          <Select
            options={dialCodeOptions}
            value={selectedDialCodeKin}
            onChange={(selected) => setDialCodeKin(selected ? selected.value : '')}
            placeholder="-- select --"
            isSearchable={true}
            styles={customDialCodeSelectStyles}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          />
          <Input
            className="form-control"
            name="mobile"
            type="number"
            placeholder={DONATION_ADD.CONTACT_NO}
            id="validationCustom01"
            min={0}
            maxLength={10}
            onInput={maxLengthCheck}
            value={contactNoKin}
            onChange={(e) => setContactNoKin(e.target.value)}
            onWheel={(e) => e.target.blur()}
          />
          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
        </div>
      </Col>
      <Col md="4 mb-4">
        <Label htmlFor="validationCustom01">{DONATION_ADD.PANCARD}</Label>
        <Input
          className="form-control"
          name="panCardNo"
          placeholder={DONATION_ADD.PANCARD}
          type="text"
          min={0}
          maxLength={10}
          onInput={maxLengthCheck}
          value={pancard}
          onChange={(e) => setPanCard(e.target.value)}
          id="panCardNo"
        />
        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
      </Col>
      <Col md="4 mb-4">
        <Label htmlFor="validationCustom01">{DONATION_ADD.AADHAAR_CARD}</Label>
        <Input
          className="form-control colorBlack"
          name="aadhaarCard"
          type="number"
          placeholder={DONATION_ADD.AADHAAR_CARD}
          id="aadhaarCard"
          min={0}
          maxLength={12}
          onInput={maxLengthCheck}
          value={aadhaarCard}
          onChange={(e) => setAadhaarCard(e.target.value)}
          onWheel={(e) => e.target.blur()}
        />
        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
      </Col>

      {!isHide && (
        <Col md="8 mb-4">
          <Label htmlFor="validationCustom01">{DONATION_ADD.BY_HAND}</Label>
          {/* FIX 1: Changed type from "text" to "textarea" */}
          <Input
            className="form-control colorBlack"
            name="byHand"
            type="textarea"
            placeholder={DONATION_ADD.BY_HAND}
            id="byHand"
            value={byHand}
            onChange={(e) => setByhand(e.target.value)}
          />
          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
        </Col>
      )}

      {isAksharvashi ? (
        <Col md={isHide ? '4 mb-4' : '4 mb-4'}>
          <Label htmlFor="validationCustom01">{DONATION_ADD.DOD}</Label>
          <TithiDropDown />
        </Col>
      ) : (
        <Col md="4 mb-4">
          <Label htmlFor="validationCustom01">{DONATION_ADD.DOB}</Label>
          {/* FIX 2: onKeyDown skips calendar open on Tab */}
          <DatePicker
            ref={dobRef}
            className="form-control colorBlack"
            selected={dob}
            onChange={(date) => {
              setDob(date);
              setIsOpen(false);
              // move focus after selecting date
              setTimeout(() => {
                nextInputRef.current?.focus();
              }, 0);
            }}
            dateFormat="dd-MM-yyyy"
            placeholderText="DD-MM-YYYY"
            open={isOpen}
            onFocus={() => setIsOpen(true)}
            onClickOutside={() => setIsOpen(false)}
            onKeyDown={(e) => {
              if (e.key === 'Tab') {
                setIsOpen(false);
                nextInputRef.current?.focus(); // force focus
              }
            }}
          />
          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
        </Col>
      )}

      <Col md="12 mb-4">
        <Label htmlFor="validationCustom01">{DONATION_ADD.ADDRESS}</Label>
        <Input
          className="form-control colorBlack"
          name="address"
          type="textarea"
          id="address"
          ref={nextInputRef}
          placeholder={DONATION_ADD.ADDRESS}
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
      </Col>
    </>
  );
};

export default DonationUserDatails;

export const PaymentTypeChackBoxes = ({ setPaymentType, paymentType, PaymentDropDown }) => {
  return (
    <Row>
      <Col
        md="12 mb-4"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '60px',
          marginTop: '15px'
        }}
      >
        <>
          {PaymentDropDown.map((elem) => {
            return (
              <Label className="d-block">
                <Input
                  className="radio_animated"
                  type="radio"
                  name="rdo-ani"
                  value={elem.label}
                  checked={paymentType && paymentType === elem.label}
                  onChange={(e) => setPaymentType(elem.label)}
                  required
                />
                {elem.label}
              </Label>
            );
          })}
        </>
      </Col>
    </Row>
  );
};
